// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"0507816b","88":"b43bfc18","132":"2c0484ad","248":"01ff40ef","266":"31ad9296","284":"91a5a250","401":"e3b60aa1","466":"c4ed6704","485":"e90df9fb","564":"bb4c5c1f","610":"363c3087","640":"c68a9dee","859":"799ca82f","892":"ca978333","928":"078eb765","986":"ca1f484d"}[chunkId] + ".chunk.js";
};